import { lighten } from "polished";

const grid = {
  outerMargin: "2rem",
  gutterWidth: "1rem"
};

const baseColors = {
  primaryDark: "#0d1940",
  primaryDarkDim: "#2c3e7d",
  primaryDarkLight: "#4f64aa",
  primaryDarkLighter: "#8494cc",
  primaryDarkMoreLighter: "#a9b6e2",
  blue: "#78ccf0",
  purple: "#2d28fe",
  yellow: "#FFCF1B",
  pink: "#ce4991",
  white: "#fff",
  blueDark: "#487386",
  text: "#353535",
  textDarkBg: "#c54960",
  danger: "#c54960",
  lightGrey: "#aaa",
  transparent50: "rgba( 255, 255, 255, 0.5)",
  transparent50Hover: "rgba(255, 255, 255, 0.65)",
  transparent75: "rgba( 255, 255, 255, 0.75)",
  transparent75Hover: "rgba(255, 255, 255, 0.9)"
};

const fontFamily = {
  sansSerif: "Montserrat",
  code: "'Anonymous Pro', monospace;"
};
const radius = {
  xs: "3px",
  sm: "5px",
  nm: "10px"
};

export const colors = {
  ...baseColors,
  purpleLight: "#3632fd",
  purpleLighter: "#b8b6fb",
  // codeHighlight: lighten(0.35, baseColors.yellow),
  // codeHighlight: "#fbf1ca",
  codeHighlight: "#e5e5e5",
  link: baseColors.blue,
  lightLink: lighten(0.1, baseColors.blue),
  linkHover: lighten(0.05, baseColors.blue),
  success: "#14b47a"
};

const gutterWidth = 1; // rem
const outerMargin = 2; // rem

const containers = {
  xs: "500px",
  sm: "700px",
  md: "900px",
  lg: "1200px"
};
const breakPoints = {
  mobile: "600",
  medium: "900",
  large: "1200"
};

const screenSizes = {
  xs: `${breakPoints.xs}em`,
  sm: `${breakPoints.sm}em`,
  md: `${breakPoints.md}em`,
  lg: `${breakPoints.lg}em`
};

const screen = {
  mobile: `${breakPoints.mobile}px`,
  medium: `${breakPoints.medium}px`,
  large: `${breakPoints.large}px`
};

const weights = {
  thin: "300",
  normal: "400",
  medium: "600",
  bold: "700"
};

const fontSizes = {
  xxs: "8px",
  xs: "10px",
  sm: "12px",
  nm: "16px",
  md: "18px",
  lg: "24px",
  xl: "36px",
  xxl: "48px",
  code: "14px"
};

const margins = {
  xs: "5px",
  sm: "10px",
  md: "20px",
  lg: "40px",
  xl: "80px",
  xxl: "120px",
  xxxl: "160px"
};

const appTheme = {
  colors,
  grid,
  radius,
  fontFamily,
  fontSizes,
  weights,
  margins,
  screenSizes,
  screen,
  containers,
  breakPoints
};

export default appTheme;



// WEBPACK FOOTER //
// ./src/themes/appTheme.js